import { ChangeEventHandler, FC, MouseEventHandler } from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { Col, Row } from "../Grid-system/Grid-system";
import { fileURL, InputFile } from "..";

interface AddImageProps {
  type: "IMAGE" | "VIDEO" | "PDF";
  id?: string;
  title?: string;
  name: string;
  accept?: string;
  value?:string
  onChange?: ChangeEventHandler<HTMLInputElement>;
  oldImage?: string;
  newImage?: any;
  oldPDF?: string;
  newPDF?: string;
  oldVideo?: string;
  newVideo?: string;
  newImages?: InputFile[];
  oldImages?: InputFile[];
  clickDeleteImage?: MouseEventHandler<HTMLSpanElement>;
  clickDeleteOldImage?: MouseEventHandler<HTMLSpanElement>;
  clickDeleteImages?: (value: string) => void;
  clickDeleteOldImages?: (value: string) => void;
  clickDeleteVideo?: MouseEventHandler<HTMLSpanElement>;
  clickDeletePDF?: MouseEventHandler<HTMLSpanElement>;
  clickDeleteOldPDF?: MouseEventHandler<HTMLSpanElement>;
  className?: string;
}

const AddImage: FC<AddImageProps> = ({
  type,
  id = "file",
  title = "أضف ملف",
  name,
  accept,
  onChange,
  value,
  oldImage,
  newImage,
  oldPDF,
  newPDF,
  oldVideo,
  newVideo,
  newImages,
  oldImages,
  clickDeleteImage,
  clickDeleteOldImage,
  clickDeleteImages,
  clickDeleteOldImages,
  clickDeleteVideo,
  clickDeletePDF,
  clickDeleteOldPDF,
  className = "",
}) => {
  return (
    <>
      <input
        id={id}
        type="file"
        name={name}
        onChange={onChange}
        value={value}
        className="hidden"
        accept={
          type === "IMAGE"
            ? "image/*"
            : type === "VIDEO"
            ? "video/*"
            : type === "PDF"
            ? "application/pdf"
            : accept
            ? accept
            : "image/*"
        }
      />
      <div
        onClick={() => document.getElementById(id)?.click()}
        className={`w-full flex justify-between  border-2 my-2 py-[9px] rounded-xl bg-[#F6F8F9] border-Secondary px-5 cursor-pointer mx-1 ${className}`}
      >
        <div>{title}</div>
        <div>
          <AiOutlineCloudUpload size={30} className="text-Main" />
        </div>
      </div>

      {type === "IMAGE" && (newImages || oldImages) ? (
        <Row className="py-4">
          {newImages?.map((e, i) => (
            <Col key={i} lg={3} sm={6}>
              <div className="relative">
                <span
                  onClick={
                    clickDeleteImages
                      ? () => clickDeleteImages(e.value)
                      : undefined
                  }
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                <img src={e.value} alt="" className="w-[250px] rounded-2xl" />
              </div>
            </Col>
          ))}
          {/* {oldImages?.map((e, i) => (
            <Col key={i} lg={3} sm={6}>
              <div className="relative">
                <span
                  onClick={
                    clickDeleteOldImages
                      ? () => clickDeleteOldImages(e.value)
                      : undefined
                  }
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                <img src={e.value} alt="" className="w-[250px] h-[250px] rounded-2xl" />
              </div>
            </Col>
          ))} */}
        </Row>
      ) : type === "VIDEO" && (oldVideo || newVideo) ? (
        <Row>
          {oldVideo && (
            <Col md={6}>
              <video controls className="rounded-2xl w-32 h-32">
                <source src={oldVideo} />
              </video>
            </Col>
          )}
          {newVideo && (
            <Col md={6}>
              <div className="relative">
                <span
                  onClick={clickDeleteVideo}
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                <video controls className="rounded-2xl">
                  <source src={newVideo} />
                </video>
              </div>
            </Col>
          )}
        </Row>
      ) : type === "PDF" && (oldPDF || newPDF) ? (
        <Row>
          {oldPDF && (
            <Col sm={6}>
              <div className="relative">
                <span
                  onClick={clickDeleteOldPDF}
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                {/* <a href={oldPDF} target="_blank" rel="noopener noreferrer"> */}
                <iframe
                  src={fileURL + oldPDF}
                  title="Uploaded PDF"
                  width="100%"
                  height="200px"
                />
                عرض الملف القديم
                {/* </a> */}
              </div>
            </Col>
          )}
          {newPDF && (
            <Col sm={6}>
              <div className="relative">
                <span
                  onClick={clickDeletePDF}
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                {/* <a href= {newPDF} target="_blank" rel="noopener noreferrer"> */}
                <iframe
                  src={newPDF}
                  title="Uploaded PDF"
                  width="100%"
                  height="200px"
                />
                عرض الملف الجديد
                {/* </a>  */}
              </div>
            </Col>
          )}
        </Row>
      ) : (
        <Row justify="center" className="pt-3">
          {newImage && (
            <Col col={6}>
              <div className="relative">
                <span
                  onClick={clickDeleteImage}
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                <img src={newImage} alt="" className=" h-[250px] rounded-2xl" />
              </div>
            </Col>
          )}
          {oldImage && (
            <Col md={6}>
              <div className="relative">
                <span
                  onClick={clickDeleteOldImage}
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                <img
                  src={fileURL + oldImage}
                  alt=""
                  className="w-[250px]  rounded-2xl"
                />
              </div>
            </Col>
          )}
        </Row>
      )}
    </>
  );
};

export default AddImage;
